export default __webpack_public_path__ + "assets/wizard-document-aacf3e6c990e5b26665b6a2533540453.svg";